import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useIsMobile } from "./mobile/DesktopOnlyScreen";
import Landing from "../pages/Landing";

// Public marketing home at "/". Authenticated users are sent to their app home;
// everyone else (and while the session resolves) sees the landing page.
export default function RootRoute() {
  const { user } = useAuth();
  const isMobile = useIsMobile();
  if (user === null) {
    // session still resolving — brief neutral splash to avoid a landing/dashboard flash
    return <div className="min-h-screen bg-[#F9FAFB]" data-testid="root-loading" />;
  }
  if (user && user !== false) {
    const dest =
      user.role === "super_admin" ? "/platform" :
      user.role === "technician" ? (isMobile ? "/mobile" : "/jobs") : "/dashboard";
    return <Navigate to={dest} replace />;
  }
  return <Landing />;
}
